<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100 p-t-190 p-b-30">
        <form class="login100-form validate-form" @submit.prevent="Login">
          <div class="login100-form-avatar">
            <img :src="Holding" alt="AVATAR" />
          </div>
          <span class="login100-form-title p-t-20 p-b-45">
            پرتال سهامداران تبرک</span
          >
          <div
            class="wrap-input100 validate-input m-b-10"
            data-validate="Username is required"
          >
            <input
              class="form-control"
              type="text"
              placeholder="نام کاربری"
              v-model="user.UserName"
              required
            />
          </div>
          <div
            class="wrap-input100 validate-input m-b-10"
            data-validate="Password is required"
          >
            <input
              class="form-control"
              type="password"
              placeholder="رمز عبور"
              v-model="user.Password"
              required
            />
          </div>
          <div class="container-login100-form-btn p-t-10">
            <button class="submit" type="submit">ورود</button>
          </div>
          <div class="text">
            <router-link to="/password" class="link">
              <p>رمزعبور خود را فراموش کرده اید ؟</p>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Holding from "../assets/img/HOLDING.png";
export default {
  name: "Login",
  data() {
    return {
      Holding,
      user: {
        UserName: "",
        Password: "",
      },
      loginError: false,
    };
  },
  methods: {
    Login() {
      this.$store
        .dispatch("login", this.user)
        .then(() => {
          this.$router.push("/");
          this.loginError = false;
        })
        .catch(() => {
          this.loginError = true;
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "نام کاربری یا رمز عبور اشتباه است",
            confirmButtonColor: "#900C3F",
            confirmButtonText: "باشه",
          });
        });
    },
  },
};
</script>
<style scoped>
input {
  text-align: center;
}
.link {
  color: #fff;
}
a:hover {
  color: #fff;
}
</style>
